<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Course Year</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-3 sm:col-span-3">
                            <breeze-label :required="true" :value="'Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <!-- <breeze-label :value="'Duration'"/>
                            <select-list required v-model="form.duration" :options="allDurations"  class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.duration:''" /> -->
                         <FormMultiselect
                            required
                            label="Duration"
                            :options="allDurations"
                            track-key="id"
                            label-key="title"
                            :object="true"
                            v-model="form.duration"
                            :placeholder="'Select Duration'"
                            :error="form.errors.duration"
                            />

                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <!-- <breeze-label :value="'Course'"/>
                            <select-list required v-model="form.course" :options="courses" :label="['title','course_type.title']" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.course:''" /> -->

                            <FormMultiselect
                            required
                            label="Course"
                            :options="courses"
                            track-key="id"
                            label-key="title"
                            :object="true"
                            v-model="form.course"
                            :placeholder="'Select Course'"
                            :error="form.errors.course"
                            />
                        </div>
                        <div v-if="form.course">
                            <breeze-label :value="'Course Type'"/>
                            <p  class="p-2 ">{{form.course.course_type.title}}</p>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checkbox="form.status" />
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <button-link :href="route('academic.courseyear.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import InputCheckbox from '@/Components/InputCheckbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Loading from '@/Components/Loading'
    import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

    export default {
        components: {
            FormMultiselect,
            Academic,
            BreezeTable,
            ButtonLink,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            InputCheckbox,
            Loading,
            SelectList
        },
        props:['courses','durations'],
        data(){
            return{
                form: useForm({
                    title: '',
                    duration: '',
                    course: '',
                    status: true,
                }),
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('academic.courseyear.store'),{
                    preserveScroll: true,
                    // onSuccess: () => this.form.reset(),
                });
            },
        },
        computed: {
            allDurations(){
                var durations = [];
                this.durations.forEach(duration => {
                    durations.push({id:duration.id,title:duration.start_month+' - '+duration.end_month});
                });
                return durations;
            },
        },
    }
</script>
